import React, { useState } from 'react';



const PawIcon = ({ size = 24, color = 'white', opacity = 1, rotation = 0 }) => (
  <svg
    width={size} height={size}
    viewBox="0 0 100 100"
    fill={color}
    style={{ opacity, transform: `rotate(${rotation}deg)`, display: 'block' }}
  >
    <ellipse cx="30" cy="20" rx="11" ry="14" />
    <ellipse cx="70" cy="20" rx="11" ry="14" />
    <ellipse cx="14" cy="42" rx="9"  ry="12" />
    <ellipse cx="86" cy="42" rx="9"  ry="12" />
    <ellipse cx="50" cy="68" rx="28" ry="26" />
  </svg>
);

const NAV_ITEMS = [
  { id: 'signup',     label: '🐾 New Client Signup',        content: 'Ready to get started? Call us at (843) 555-0192 or email hello@happytailssc.com to schedule your free meet-and-greet!' },
  { id: 'locations',  label: '📍 Locations',                content: 'We serve Mount Pleasant, Daniel Island, James Island, West Ashley, and Downtown Charleston. GPS tracking available in app.' },
  { id: 'euthanasia', label: '🌈 Dog Euthanasia Services 💉', content: 'We offer compassionate end-of-life care and peaceful home euthanasia services. Please call (843) 555-0192 to speak with our care team.' },
  { id: 'recipes',    label: '🍖 Recipes',                   content: 'Try our famous Peanut Butter Pupcakes! Mix 1 cup flour, 1 egg, 1/3 cup peanut butter, 1/3 cup applesauce. Bake at 350°F for 25 min. Dogs love them!' },
];

export default function Login({ onLogin }) {
  const [dogFirstName,  setDogFirstName]  = useState('');
  const [dogLastName,   setDogLastName]   = useState('');
  const [showPassword,  setShowPassword]  = useState(false);
  const [error,         setError]         = useState('');
  const [shaking,       setShaking]       = useState(false);
  const [activeNav,     setActiveNav]     = useState(null);

  const handleSubmit = async () => {
    const username = dogFirstName.trim().toLowerCase();
    const password = dogLastName.trim();
    if (!username || !password) {
      setError("Please enter your pup's first and last name 🐾");
      setShaking(true);
      setTimeout(() => setShaking(false), 600);
      return;
    }
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });
      if (res.ok) {
        setError('');
        onLogin(password === 'Raiders' ? 'guest' : username);
      } else {
        setError("We couldn't find your pup! Please check your dog's name.");
        setShaking(true);
        setTimeout(() => setShaking(false), 600);
      }
    } catch (err) {
      setError("Service unavailable. Please try again later.");
      setShaking(true);
      setTimeout(() => setShaking(false), 600);
    }
  };

  const handleKey = (e) => {
    if (e.key === 'Enter') handleSubmit();
  };

  return (
    <div style={s.root}>
      {/* Cartoon background scene */}
      <svg style={s.bgSvg} viewBox="0 0 1200 700" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
        {/* Sky */}
        <rect width="1200" height="700" fill="#87CEEB"/>
        {/* Sun */}
        <circle cx="980" cy="90" r="55" fill="#FFD700" opacity="0.9"/>
        <circle cx="980" cy="90" r="42" fill="#FFE566"/>
        {/* Clouds */}
        <g opacity="0.9">
          <ellipse cx="150" cy="110" rx="70" ry="38" fill="white"/>
          <ellipse cx="200" cy="95" rx="55" ry="38" fill="white"/>
          <ellipse cx="100" cy="100" rx="45" ry="30" fill="white"/>
        </g>
        <g opacity="0.85">
          <ellipse cx="500" cy="80" rx="60" ry="32" fill="white"/>
          <ellipse cx="545" cy="68" rx="48" ry="32" fill="white"/>
          <ellipse cx="460" cy="74" rx="40" ry="26" fill="white"/>
        </g>
        <g opacity="0.8">
          <ellipse cx="780" cy="130" rx="50" ry="28" fill="white"/>
          <ellipse cx="820" cy="118" rx="40" ry="28" fill="white"/>
          <ellipse cx="748" cy="124" rx="36" ry="22" fill="white"/>
        </g>
        {/* Rolling hills - back */}
        <ellipse cx="300" cy="620" rx="420" ry="200" fill="#90C84A"/>
        <ellipse cx="900" cy="640" rx="500" ry="220" fill="#7DBF3A"/>
        {/* Ground */}
        <rect x="0" y="520" width="1200" height="180" fill="#5AAD2A"/>
        {/* Flowers */}
        {[80,160,250,340,420,560,640,720,820,900,1020,1100].map((x,i) => (
          <g key={i} transform={`translate(${x},${490+((i%3)*15)})`}>
            <rect x="-2" y="0" width="4" height="30" fill="#4A9E20"/>
            <circle cx="0" cy="-4" r="8" fill={['#FF6B9D','#FFD700','#FF8C42','#C084FC'][i%4]} opacity="0.9"/>
            <circle cx="0" cy="-4" r="4" fill="white" opacity="0.6"/>
          </g>
        ))}
        {/* Trees */}
        <g transform="translate(60,320)">
          <rect x="-10" y="80" width="20" height="80" fill="#8B6914"/>
          <circle cx="0" cy="50" r="65" fill="#3DAA2A"/>
          <circle cx="-30" cy="70" r="45" fill="#4BBF35"/>
          <circle cx="30" cy="65" r="48" fill="#3DAA2A"/>
        </g>
        <g transform="translate(1100,290)">
          <rect x="-10" y="80" width="20" height="90" fill="#8B6914"/>
          <circle cx="0" cy="45" r="70" fill="#3DAA2A"/>
          <circle cx="-32" cy="68" r="48" fill="#4BBF35"/>
          <circle cx="32" cy="62" r="50" fill="#3DAA2A"/>
        </g>
        <g transform="translate(200,350)">
          <rect x="-8" y="60" width="16" height="60" fill="#8B6914"/>
          <circle cx="0" cy="35" r="50" fill="#4BBF35"/>
          <circle cx="-22" cy="52" r="35" fill="#3DAA2A"/>
          <circle cx="22" cy="48" r="37" fill="#4BBF35"/>
        </g>

        {/* Dog 1 - golden retriever style, running left */}
        <g transform="translate(320,440)">
          {/* body */}
          <ellipse cx="0" cy="0" rx="48" ry="26" fill="#E8A840"/>
          {/* head */}
          <circle cx="44" cy="-18" r="22" fill="#E8A840"/>
          {/* snout */}
          <ellipse cx="58" cy="-12" rx="12" ry="9" fill="#D4922E"/>
          <ellipse cx="62" cy="-10" rx="5" ry="4" fill="#222"/>
          {/* eye */}
          <circle cx="52" cy="-22" r="4" fill="#222"/>
          <circle cx="53" cy="-23" r="1.5" fill="white"/>
          {/* ear */}
          <ellipse cx="36" cy="-28" rx="10" ry="16" fill="#C8821A" transform="rotate(-20,36,-28)"/>
          {/* tail */}
          <path d="M-44,0 Q-70,-30 -60,-50" stroke="#E8A840" strokeWidth="10" fill="none" strokeLinecap="round"/>
          {/* legs */}
          <rect x="-28" y="20" width="12" height="30" rx="6" fill="#D4922E"/>
          <rect x="-8" y="22" width="12" height="28" rx="6" fill="#D4922E"/>
          <rect x="14" y="20" width="12" height="30" rx="6" fill="#D4922E"/>
          <rect x="30" y="18" width="12" height="28" rx="6" fill="#D4922E"/>
          {/* tongue */}
          <ellipse cx="64" cy="-4" rx="5" ry="7" fill="#FF6B9D"/>
        </g>

        {/* Dog 2 - spotted dalmatian style */}
        <g transform="translate(720,455)">
          <ellipse cx="0" cy="0" rx="44" ry="24" fill="white"/>
          <circle cx="3" cy="-8" r="6" fill="#333" opacity="0.7"/>
          <circle cx="-15" cy="5" r="5" fill="#333" opacity="0.7"/>
          <circle cx="20" cy="8" r="4" fill="#333" opacity="0.6"/>
          <circle cx="-5" cy="-16" r="4" fill="#333" opacity="0.5"/>
          {/* head */}
          <circle cx="42" cy="-16" r="20" fill="white"/>
          <circle cx="46" cy="-10" r="5" fill="#333" opacity="0.6"/>
          <ellipse cx="54" cy="-10" rx="10" ry="8" fill="#eee"/>
          <ellipse cx="58" cy="-8" rx="4" ry="3" fill="#222"/>
          <circle cx="50" cy="-19" r="3.5" fill="#222"/>
          <circle cx="51" cy="-20" r="1" fill="white"/>
          <ellipse cx="34" cy="-26" rx="8" ry="13" fill="#ccc" transform="rotate(-15,34,-26)"/>
          {/* tail */}
          <path d="M-40,0 Q-65,-20 -58,-42" stroke="white" strokeWidth="9" fill="none" strokeLinecap="round"/>
          <path d="M-40,0 Q-65,-20 -58,-42" stroke="#ddd" strokeWidth="5" fill="none" strokeLinecap="round"/>
          {/* legs */}
          <rect x="-24" y="18" width="11" height="28" rx="5" fill="#eee"/>
          <rect x="-6" y="20" width="11" height="26" rx="5" fill="#eee"/>
          <rect x="12" y="18" width="11" height="28" rx="5" fill="#eee"/>
          <rect x="28" y="16" width="11" height="26" rx="5" fill="#eee"/>
          <ellipse cx="58" cy="-2" rx="4" ry="6" fill="#FF6B9D"/>
        </g>

        {/* Dog 3 - small fluffy white dog */}
        <g transform="translate(540,468)">
          <ellipse cx="0" cy="0" rx="32" ry="20" fill="#F5F0E8"/>
          {/* fluffy texture */}
          <ellipse cx="-10" cy="-8" rx="14" ry="10" fill="white"/>
          <ellipse cx="10" cy="-10" rx="12" ry="9" fill="white"/>
          <ellipse cx="0" cy="-14" rx="10" ry="8" fill="#F5F0E8"/>
          {/* head */}
          <circle cx="30" cy="-14" r="16" fill="white"/>
          <circle cx="28" cy="-10" r="5" fill="#F5DDD5"/>
          <ellipse cx="36" cy="-8" rx="7" ry="6" fill="#F5DDD5"/>
          <ellipse cx="39" cy="-7" rx="3" ry="2.5" fill="#222"/>
          <circle cx="34" cy="-17" r="3" fill="#222"/>
          <circle cx="35" cy="-18" r="1" fill="white"/>
          <ellipse cx="24" cy="-22" rx="7" ry="10" fill="#F0EBE0" transform="rotate(-10,24,-22)"/>
          {/* tail */}
          <path d="M-30,0 Q-50,-15 -44,-32" stroke="white" strokeWidth="8" fill="none" strokeLinecap="round"/>
          {/* legs */}
          <rect x="-18" y="16" width="9" height="22" rx="4" fill="#F0EBE0"/>
          <rect x="-4" y="17" width="9" height="20" rx="4" fill="#F0EBE0"/>
          <rect x="10" y="16" width="9" height="22" rx="4" fill="#F0EBE0"/>
          <rect x="22" y="14" width="9" height="20" rx="4" fill="#F0EBE0"/>
        </g>

        {/* Fence */}
        {[0,60,120,180,240].map((x,i) => (
          <g key={i} transform={`translate(${x},490)`}>
            <rect x="5" y="-40" width="8" height="60" rx="3" fill="white" opacity="0.85"/>
            <polygon points="9,-40 5,-55 13,-55" fill="white" opacity="0.85"/>
          </g>
        ))}
        <rect x="0" y="458" width="300" height="8" rx="4" fill="white" opacity="0.75"/>
        <rect x="0" y="478" width="300" height="8" rx="4" fill="white" opacity="0.75"/>

        {/* Path */}
        <ellipse cx="600" cy="680" rx="180" ry="40" fill="#D4B483" opacity="0.5"/>
        <ellipse cx="600" cy="650" rx="120" ry="25" fill="#D4B483" opacity="0.4"/>
      </svg>

      {/* Slight overlay to make card readable */}
      <div style={s.overlay} />



      {/* Nav bar */}
      <div style={s.navbar}>
        <div style={s.navBrand}>
          <PawIcon size={22} color="white" opacity={0.9} />
          <span style={s.navBrandText}>Happy Tails</span>
        </div>
        <div style={s.navLinks}>
          {NAV_ITEMS.map(item => (
            <button
              key={item.id}
              style={{
                ...s.navBtn,
                ...(activeNav === item.id ? s.navBtnActive : {}),
              }}
              onClick={() => setActiveNav(activeNav === item.id ? null : item.id)}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      {/* Nav dropdown */}
      {activeNav && (
        <div style={s.dropdown}>
          <p style={s.dropdownText}>
            {NAV_ITEMS.find(n => n.id === activeNav).content}
          </p>
        </div>
      )}

      {/* Login card */}
      <div style={{ ...s.cardWrap, animation: shaking ? 'shake 0.5s ease' : 'none' }}>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&family=Pacifico&display=swap');
          @keyframes shake {
            0%,100% { transform: translateX(0); }
            20%      { transform: translateX(-8px); }
            40%      { transform: translateX(8px); }
            60%      { transform: translateX(-6px); }
            80%      { transform: translateX(6px); }
          }
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(20px); }
            to   { opacity: 1; transform: translateY(0); }
          }
          .ht-input:focus { outline: none; border-color: #f97316 !important; box-shadow: 0 0 0 3px rgba(249,115,22,0.18) !important; }
          .ht-btn:hover   { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(249,115,22,0.45) !important; }
          .ht-btn:active  { transform: translateY(0); }
          .ht-navbtn:hover { background: rgba(255,255,255,0.2) !important; }
        `}</style>

        <div style={s.card}>
          {/* Brand header */}
          <div style={s.cardHeader}>
            <div style={s.brandRow}>
              <PawIcon size={32} color="#f97316" opacity={1} />
              <span style={s.brandName}>Happy Tails</span>
            </div>
            <p style={s.brandSub}>Dog Walking &amp; Pet Care · Charleston, SC</p>
          </div>

          <div style={s.divider} />

          <h2 style={s.cardTitle}>🐶 Check On Your Pup</h2>
          <p style={s.cardSub}>Enter your dog's name to see today's updates</p>

          {/* Fields */}
          <div style={s.fieldRow}>
            <div style={s.field}>
              <label style={s.label}>Dog's First Name</label>
              <input
                className="ht-input"
                style={s.input}
                type="text"
                placeholder="e.g. Buddy"
                value={dogFirstName}
                onChange={e => setDogFirstName(e.target.value)}
                onKeyDown={handleKey}
                autoComplete="off"
              />
            </div>
            <div style={s.field}>
              <label style={s.label}>Dog's Last Name</label>
              <div style={s.pwWrap}>
                <input
                  className="ht-input"
                  style={{ ...s.input, paddingRight: '40px' }}
                  type={showPassword ? 'text' : 'password'}
                  placeholder="e.g. Johnson"
                  value={dogLastName}
                  onChange={e => setDogLastName(e.target.value)}
                  onKeyDown={handleKey}
                  autoComplete="off"
                />
                <button
                  style={s.eyeBtn}
                  onClick={() => setShowPassword(p => !p)}
                  tabIndex={-1}
                  title={showPassword ? 'Hide' : 'Show'}
                >
                  {showPassword ? '🙈' : '👁️'}
                </button>
              </div>
            </div>
          </div>

          {/* Error */}
          {error && <div style={s.error}>{error}</div>}

          {/* Submit */}
          <button
            className="ht-btn"
            style={s.btn}
            onClick={handleSubmit}
          >
            Find My Dog 🐾
          </button>

          <p style={s.footer}>
            Trusted by 2,400+ pet owners in the Lowcountry<br />
            <span style={{ opacity: 0.6 }}>Insured · Bonded · Background-Checked</span>
          </p>


        </div>
      </div>

      {/* Bottom badge */}
      <div style={s.badge}>
        <PawIcon size={14} color="white" opacity={0.7} />
        <span>Happy Tails Dog Walking Co. · Est. 2018 · Charleston, SC</span>
      </div>
    </div>
  );
}

const s = {
  root: {
    position: 'fixed', inset: 0,
    fontFamily: "'Nunito', sans-serif",
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  bgSvg: {
    position: 'absolute', inset: 0,
    width: '100%', height: '100%',
    zIndex: 1,
  },
  overlay: {
    position: 'absolute', inset: 0,
    background: 'linear-gradient(to right, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.05) 50%, rgba(0,0,0,0.45) 100%)',
    zIndex: 2,
  },
  navbar: {
    position: 'absolute', top: 0, left: 0, right: 0,
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 28px',
    background: 'rgba(0,0,0,0.35)',
    backdropFilter: 'blur(8px)',
    borderBottom: '1px solid rgba(255,255,255,0.1)',
  },
  navBrand: {
    display: 'flex', alignItems: 'center', gap: '9px',
  },
  navBrandText: {
    fontFamily: "'Pacifico', cursive",
    color: 'white',
    fontSize: '20px',
    letterSpacing: '0.3px',
  },
  navLinks: {
    display: 'flex', gap: '6px',
  },
  navBtn: {
    background: 'rgba(255,255,255,0.12)',
    border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: '20px',
    color: 'white',
    padding: '6px 14px',
    fontSize: '12.5px',
    fontFamily: "'Nunito', sans-serif",
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background 0.15s',
    whiteSpace: 'nowrap',
  },
  navBtnActive: {
    background: 'rgba(249,115,22,0.5)',
    borderColor: '#f97316',
  },
  dropdown: {
    position: 'absolute', top: '62px', right: '28px',
    zIndex: 10,
    background: 'rgba(255,255,255,0.96)',
    borderRadius: '12px',
    padding: '14px 18px',
    maxWidth: '320px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
    backdropFilter: 'blur(4px)',
  },
  dropdownText: {
    margin: 0,
    fontSize: '13.5px',
    color: '#44403c',
    lineHeight: 1.6,
    fontWeight: '600',
  },
  cardWrap: {
    position: 'relative', zIndex: 5,
    width: '100%', maxWidth: '400px',
    padding: '0 32px 0 0',
  },
  card: {
    background: 'rgba(255,255,255,0.97)',
    borderRadius: '24px',
    padding: '32px 36px 24px',
    boxShadow: '0 24px 64px rgba(0,0,0,0.4)',
    animation: 'fadeUp 0.5s ease',
  },
  cardHeader: {
    textAlign: 'center',
    marginBottom: '4px',
  },
  brandRow: {
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
    marginBottom: '4px',
  },
  brandName: {
    fontFamily: "'Pacifico', cursive",
    fontSize: '28px',
    color: '#f97316',
    lineHeight: 1,
  },
  brandSub: {
    margin: 0,
    fontSize: '12.5px',
    color: '#a8a29e',
    fontWeight: '600',
    letterSpacing: '0.3px',
  },
  divider: {
    height: '1px',
    background: 'linear-gradient(to right, transparent, #e7e5e4, transparent)',
    margin: '18px 0',
  },
  cardTitle: {
    margin: '0 0 4px',
    fontSize: '20px',
    fontWeight: '800',
    color: '#1c1917',
    textAlign: 'center',
  },
  cardSub: {
    margin: '0 0 20px',
    fontSize: '13px',
    color: '#78716c',
    textAlign: 'center',
    fontWeight: '600',
  },
  fieldRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    marginBottom: '16px',
  },
  field: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    fontSize: '12px',
    fontWeight: '700',
    color: '#57534e',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  input: {
    width: '100%',
    padding: '11px 14px',
    border: '2px solid #e7e5e4',
    borderRadius: '12px',
    fontSize: '14px',
    fontFamily: "'Nunito', sans-serif",
    fontWeight: '600',
    color: '#1c1917',
    background: '#fafaf9',
    transition: 'border-color 0.15s, box-shadow 0.15s',
    boxSizing: 'border-box',
  },
  pwWrap: {
    position: 'relative',
  },
  eyeBtn: {
    position: 'absolute', right: '10px', top: '50%',
    transform: 'translateY(-50%)',
    background: 'none', border: 'none',
    cursor: 'pointer', fontSize: '15px',
    padding: '2px', lineHeight: 1,
  },
  error: {
    background: '#fff7ed',
    border: '1px solid #fed7aa',
    borderRadius: '10px',
    padding: '10px 14px',
    fontSize: '13px',
    color: '#c2410c',
    fontWeight: '700',
    marginBottom: '14px',
  },
  btn: {
    width: '100%',
    padding: '13px',
    background: 'linear-gradient(135deg, #f97316, #ea580c)',
    color: 'white',
    border: 'none',
    borderRadius: '14px',
    fontSize: '16px',
    fontFamily: "'Nunito', sans-serif",
    fontWeight: '800',
    cursor: 'pointer',
    letterSpacing: '0.3px',
    transition: 'all 0.18s ease',
    boxShadow: '0 4px 14px rgba(249,115,22,0.35)',
  },
  footer: {
    fontSize: '11.5px',
    color: '#a8a29e',
    textAlign: 'center',
    margin: '14px 0 12px',
    fontWeight: '600',
    lineHeight: 1.6,
  },
  badge: {
    position: 'absolute', bottom: '18px',
    left: '50%', transform: 'translateX(-50%)',
    zIndex: 5,
    display: 'flex', alignItems: 'center', gap: '7px',
    color: 'rgba(255,255,255,0.7)',
    fontSize: '12px',
    fontFamily: "'Nunito', sans-serif",
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
};
